import React, { ChangeEvent } from "react";
import {
    Table, Input, Row, Col, Pagination, Button, Spin, notification, Form, 
    FormInstance, Modal, Popconfirm, Select, TreeSelect, Badge, Breadcrumb, 
    Dropdown, Menu, Space, InputNumber, Empty,
    Steps,
} from "antd";
import {
    BasicStateForListModel
} from "../models";
import { Link, NavLink, RouteComponentProps } from "react-router-dom";
import { RootStoreModel } from "../../redux/reducers";
import { connect } from "react-redux";
import { PlusOutlined, InfoCircleOutlined, CheckCircleFilled, StopFilled } from '@ant-design/icons';
import { gaEvent } from "../../withTracker"
import { getLdapList, addOrUpdateLdap, deleteLdap,syncLdapUsers } from "../../axios/api.account"

import { Translation } from "react-i18next";
import { stat } from "fs";
import { error } from "console";

interface stateModel extends BasicStateForListModel {
    name: string,
    showAddForm: boolean,
    isUpdate: boolean,
    ldapId: string,
    search: string,
    step: number,
    isSubmit: boolean,
    step1Obj: any,
    step2Obj: any,
    step3Obj: any,
}
interface propsModel extends RouteComponentProps<any, any, any> {}

const { Column } = Table;
const { Item } = Form;
const mapStatetoProps = (state: RootStoreModel) => ({});

class LdapIndex extends React.Component<propsModel, stateModel> {
    formRef = React.createRef<FormInstance>();
    formStepRef = React.createRef<FormInstance>();
    formThreeStepRef = React.createRef<FormInstance>();
    constructor(props: propsModel) {
        super(props);
        this.state = {
            name: "LdapIndex",
            showAddForm: false,
            isUpdate: false,
            pageIndex: 1,
            pageSize: 20,
            totalCount: 0,
            loading: false,
            data: [],
            columns: [],
            ldapId: "",
            search: "",
            step: 0,
            isSubmit: false,
            step1Obj: {directoryType: "ActiveDirectory"},
            step2Obj: {},
            step3Obj: {status:"Active", syncFrequency:"Daily"}
        }
        this.Init();
    }

    Init() {
        this.getList();
    }

    getList(
        pageIndex = this.state.pageIndex, 
        pageSize = this.state.pageSize
    ) {
        var params = { search: this.state.search, pageIndex, pageSize }
        getLdapList(params).then(
            (res) => {
                this.setState({
                    data: res.dataList,
                    pageIndex: res.pageIndex,
                    pageSize: res.pageSize,
                    totalCount: res.totalCount,
                    loading: false
                })
                // if (!res.dataList.length) {
                //     notification.warning({ message: <Translation>{t => {return t("查询数据为空")}}</Translation> })
                // }
            },
            error => {
                console.log(error);                
                notification.error({ message: <Translation>{t => {return t("查询失败")}}</Translation> })
                this.setState({ loading: false })
            }
        )
    }

    onSearch() {   
        this.setState({ loading: true })     
        this.getList(1);
    }
    
    formOK = () => {
        this.formThreeStepRef.current?.validateFields().then(
            (res) => { 
                this.setState({loading: true });
                const params = {
                    id: this.state.ldapId,
                    directoryType: this.state.step1Obj.directoryType,
                    host: this.state.step1Obj.host,
                    baseDN: this.state.step1Obj.baseDN,
                    bindDN: this.state.step1Obj.bindDN,
                    bindDNPassword: this.state.step1Obj.bindDNPassword,
                    userIdentifier: this.state.step2Obj.userIdentifier,
                    properyMappings: {
                        userName: this.state.step2Obj.userName,
                        email: this.state.step2Obj.email,
                        phoneNumber: this.state.step2Obj.phoneNumber,
                        orgName: this.state.step2Obj.orgName,
                        number: this.state.step2Obj.number,
                    },
                    name: res.name,
                    syncFrequency: res.syncFrequency,
                    status: res.status
                }
                this.putLdap(params)
            },
            error => {
                console.log(error);
            }
        )
    }

    formCancel = () => {
        this.setState({ 
            showAddForm: false, 
            loading: false,
            step: 0,
            isSubmit: false
        })
    }

    openModal = () => {
        var obj1 = {directoryType: "ActiveDirectory"};
        var obj2 = {};
        var obj3 = {status:"Active", syncFrequency:"Daily"};

        this.setState({ 
            showAddForm: true, 
            isUpdate: false,
            step1Obj: obj1,
            step2Obj: obj2,
            step3Obj: obj3,
            step: 0,
            ldapId: ""
        });
        this.formRef?.current?.setFieldsValue({
            directoryType: "ActiveDirectory",
            host: "",
            baseDN: "",
            bindDN: "",
            bindDNPassword: ""
        });          
    };

    updateLdap = (row: any) => {       
        var obj1 = {
            directoryType: row.directoryType,
            host: row.host,
            baseDN: row.baseDN,
            bindDN: row.bindDN,
            bindDNPassword: row.bindDNPassword
        };
        var obj2 = {
            userIdentifier: row.userIdentifier,
            userName: row.properyMappings?.userName,
            email: row.properyMappings?.email,
            phoneNumber: row.properyMappings?.phoneNumber,
            orgName: row.properyMappings?.orgName,
            number: row.properyMappings?.number
        };
        var obj3 = {
            name: row.name,
            syncFrequency: row.syncFrequency,
            status: row.status
        };
        this.formRef.current?.setFieldsValue(obj1);
        // this.formStepRef.current?.setFieldsValue({
        //     userIdentifier: row.userIdentifier,
        //     userName: row.properyMappings?.userName,
        //     email: row.properyMappings?.email,
        //     phoneNumber: row.properyMappings?.phoneNumber,
        //     orgName: row.properyMappings?.orgName,
        //     number: row.properyMappings?.number
        // });
        // this.formThreeStepRef.current?.setFieldsValue({
        //     name: row.name,
        //     syncFrequency: row.syncFrequency,
        //     status: row.status
        // });
        this.setState({ 
            showAddForm: true, 
            isUpdate: true, 
            ldapId: row.id,
            step: 0,
            step1Obj: obj1,
            step2Obj: obj2,
            step3Obj: obj3
        })
    }

    syncLdap = (row: any) => {
        syncLdapUsers(row.id).then(
            ()=>{
                this.getList(1);
                notification.success({ message: <Translation>{t => {return t("同步成功")}}</Translation> });
            },
            error => {
                notification.error({ message: <Translation>{t => {return t("同步失败")}}</Translation> });
            }
        );
    }

    putLdap(params: any) {
        console.log(params);
        addOrUpdateLdap(params).then(
            () => {
                // this.getList();
                this.formRef.current?.resetFields();
                this.formStepRef.current?.resetFields();
                this.formThreeStepRef.current?.resetFields();
                this.setState({ 
                    showAddForm: false, 
                    loading: false,
                    ldapId: ""
                })
                this.getList(1);
                if (this.state.isUpdate) {
                    notification.success({ message: <Translation>{t => {return t("修改成功")}}</Translation> });
                } 
                else {
                    notification.success({ message: <Translation>{t => {return t("添加成功")}}</Translation> });
                }
            }, 
            error => {
                console.log(error);
                this.setState({ loading: false });
                if (this.state.isUpdate) {
                    notification.error({ message: <Translation>{t => {return t("修改失败")}}</Translation> });
                } 
                else {
                    notification.error({ message: <Translation>{t => {return t("添加失败")}}</Translation> });
                }
            }
        )
    }

    componentDidMount() {
    }

    deleteLdap = (id: string) => {
        deleteLdap(id).then(
            () => {
                notification.success({ message: <Translation>{t => {return t("删除成功")}}</Translation> });
                this.getList();
            },
            () => {
                notification.error({ message: <Translation>{t => {return t("删除失败")}}</Translation> });
            }
        )
    }

    oneStep(){
      this.formRef?.current?.validateFields().then(res=>{
        this.setState({step: this.state.step + 1, step1Obj: res });
      })
    }

    twoStep(){
        this.formStepRef?.current?.validateFields().then(res=>{
            this.setState({step: this.state.step + 1, step2Obj: res });
        })
    }

    prevStep() {
        console.log(this.state.step,this.state.step1Obj);
        if(this.state.step == 1)
        {
            this.formRef?.current?.setFieldsValue(this.state.step1Obj);
        }
        else if(this.state.step == 2)
        {
            this.formStepRef?.current?.setFieldsValue(this.state.step2Obj);
        }
        this.setState({step: this.state.step - 1 });
    }

    render() {
        const { 
            data, 
            showAddForm, 
            isUpdate, 
            loading,
            pageIndex, 
            pageSize, 
            totalCount,
            step,
            isSubmit,
            step1Obj,
            step2Obj,
            step3Obj
        } = this.state;
        
        return (
            <Translation>{t => {
                return (
                    <>
                        <div>
                            <h5 className="breadcrumbTop py-2">
                                <Breadcrumb>
                                    <Breadcrumb.Item>{t("系统集成")}</Breadcrumb.Item>
                                    <Breadcrumb.Item>{t("Active Directory ")}</Breadcrumb.Item>
                                </Breadcrumb>
                                <Row style={{padding: "32px 0 11px 0"}}>
                                    <Space>
                                        <img style={{width:30}} src="/images/openapi.png" alt="" />
                                        <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("Active Directory ")}</span>
                                    </Space>
                                </Row>
                            </h5>
                            <Row style={{ width: "100%" }}>
                                <div className="borderBox">
                                    <Row className="mb-3">
                                        <Col span={8}>
                                            <Form.Item label={t("配置名称")}  name="name">
                                                <Input  placeholder={t("输入配置名称")} onChange={(e) => {this.setState({search: e.target.value})}}></Input>
                                            </Form.Item>
                                        </Col>
                                        <Col offset={1}>
                                            <Form.Item>
                                                <Button type="primary" onClick={
                                                    () => { 
                                                        this.onSearch();
                                                    }
                                                }>{t("查询")}
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="borderBox">
                                    <Row style={{ width: "100%", marginBottom: 8 }}>
                                        <Col className="ms-auto">
                                            <Button type="primary" onClick={
                                                () => {
                                                    this.openModal();
                                                }
                                            }><PlusOutlined />{t("添加配置")}
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Table 
                                        size="middle" 
                                        dataSource={data} 
                                        style={{width: "100%"}} 
                                        pagination={false}
                                        locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                    >
                                        <Column
                                            key="key"
                                            dataIndex="key"
                                            title={t("序号")}
                                            render={(v, d, i) => i + 1}
                                        ></Column>
                                        <Column
                                            title={t("配置名称")}
                                            key="name"
                                            dataIndex="name"
                                        ></Column>
                                        <Column
                                            title={t("域名")}
                                            key="host"
                                            dataIndex="host"
                                        ></Column>
                                        <Column 
                                            title={t("最近同步时间")} 
                                            key="lastSyncTime" 
                                            dataIndex="lastSyncTime"
                                        ></Column>
                                        <Column key="status" dataIndex="status" title={t("状态")}
                                            render={(v) => (
                                            <> 
                                                {v=="Active"&&(
                                                    <span ><CheckCircleFilled  style={{color:"#4CB8BE",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                                                )}
                                                {v=="Disabled"&&(
                                                    <span><StopFilled  style={{color:"#C9A063",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                                                )}
                                            </>
                                            )}
                                        ></Column>
                                        <Column
                                            title={t("操作")}
                                            key="id"
                                            dataIndex="id"
                                            render={(v, row: any, index) => {                                        
                                                return (
                                                    <Space size={8}>
                                                        <Button type="link" block onClick={
                                                            () => {
                                                                this.syncLdap(row);
                                                            }
                                                        }>{t("同步")}
                                                        </Button>
                                                        <Button type="link" block onClick={
                                                            () => {
                                                                this.updateLdap(row);
                                                            }
                                                        }>{t("编辑")}
                                                        </Button>
                                                        <Popconfirm
                                                            title={`${t("确认删除")}？`}
                                                            onConfirm={() => {
                                                                this.deleteLdap(row.id);
                                                            }}
                                                            okText={t("确认")}
                                                            cancelText={t("取消")}
                                                        >
                                                            <Button type="link" block>{t("删除")}</Button>
                                                        </Popconfirm>
                                                    </Space>
                                                )
                                            }}></Column>
                                    </Table>
                                    <Pagination
                                        style={{ textAlign: "right", marginTop: "20px" }}
                                        pageSize={ pageSize }
                                        current={ pageIndex }
                                        total={ totalCount }
                                        showTotal={ (total, range) => `${range[0]}-${range[1]} / ${total} ${t("条")}` }
                                        onChange={ (page, pageSize) => this.getList(page, pageSize) }
                                        onShowSizeChange={ (current, size) => this.getList(current, size) }
                                    ></Pagination>
                                </div>
                            </Row>
                        </div>
                        <Modal
                            confirmLoading={loading}
                            maskClosable={false}
                            open={showAddForm}
                            destroyOnClose={true}
                            title={this.state.isUpdate ? t("修改配置") : t("添加配置")}
                            forceRender={true}
                            width={"850px"}
                            footer={null}
                            // onOk={() => this.formOK()}
                            onCancel={() => this.formCancel()}
                            // okText={t("确认")}
                            // cancelText={t("取消")}
                        >
                            <Steps
                                current={step}
                                className="mt-4"
                                style={{width:'90%'}}
                                items={[
                                    {
                                    title: t('配置服务连接')
                                    },
                                    {
                                    title: t('账号绑定与属性映射')
                                    },
                                    {
                                    title: t('开启服务')
                                    },
                                ]}
                                />
                                <div className="mx-auto" style={{ marginTop: "50px",width:'90%' }}>
                                <div style={{ }}>
                                    {step === 0 && (
                                    <Form
                                        ref={this.formRef}
                                        name="basic"
                                        labelCol={{ span: 4 }}
                                        wrapperCol={{ span: 16 }}
                                        //style={{ maxWidth: 600 }}
                                        autoComplete="off"
                                        initialValues={step1Obj}
                                    >
                                        <Form.Item
                                            label={t("目录类型")}
                                            name="directoryType"
                                            rules={[
                                                { 
                                                required: true, 
                                                message: t("请选择目录类型") 
                                                }
                                            ]}
                                        >
                                            <Select>
                                                <Select.Option value="ActiveDirectory">Active Directory</Select.Option>
                                                <Select.Option value="AppleOpenDirectory">Apple Open Directory</Select.Option>
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            label={t("服务器地址")}
                                            name="host"
                                            rules={[{ required: true, message: t('请输入服务器地址') }]}
                                        >
                                            <Input placeholder={"请输入服务器地址和端口，如Idap://ldap.example.com:389"} autoComplete="off" />
                                        </Form.Item>
                                        <Form.Item
                                            label={t("Base DN")}
                                            name="baseDN"
                                            rules={[{ required: true, message: t('请输入Base DN') }]}
                                        >
                                            <Input placeholder={t("请输入Base DN，仅同步目录范围以内的目录节点和用户")} autoComplete="off" />
                                        </Form.Item>
                                        <Form.Item
                                            label={t("Bind DN")}
                                            name="bindDN"
                                            rules={[{ required: true, message: t('请输入Bind DN') }]}
                                        >
                                            <Input placeholder={t("请输入完整的Bind DN")} autoComplete="off" />
                                        </Form.Item>
                                        <Form.Item
                                            label={t("Bind DN 密码")}
                                            name="bindDNPassword"
                                            rules={[
                                                { 
                                                    required: true,
                                                    message: t('请输入Bind DN 密码')
                                                }
                                            ]}
                                        >
                                            <Input.Password />
                                        </Form.Item>
                                        <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
                                            <Button type="primary" onClick={() => { this.oneStep(); } } style={{width:"30%"}} htmlType="submit">
                                                {t("下一步")}
                                            </Button>
                                            <Button type="primary"  onClick={() => { this.formCancel() }} style={{width:"30%", marginLeft:"40px"}} htmlType="submit">
                                                {t("取消")}
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                    )}
                                    {step === 1 && (
                                    <Form
                                        ref={this.formStepRef}
                                        name="basic"
                                        labelCol={{ span: 4 }}
                                        wrapperCol={{ span: 16 }}
                                        //style={{ maxWidth: 600 }}
                                        autoComplete="off"
                                        initialValues={step2Obj}
                                    >
                                        <Form.Item
                                            label={t("用户唯一标识")}
                                            name="userIdentifier"
                                            rules={[{ required: true, message: t("请输入用户唯一标识") }]}
                                        >
                                            <Input autoComplete="off" />
                                        </Form.Item>
                                        <Form.Item
                                            label="用户属性映射"
                                        >
                                            <span style={{ fontSize:12, color: "grey" }}>{t("需要保证登录账号、用于账号绑定识别的属性字段的唯一性，且必须填写。")}</span>
                                        </Form.Item>
                                        <Form.Item
                                            label={t("姓名")}
                                            name="userName"
                                            rules={[{ required: true }]}
                                        >
                                            <Input autoComplete="off" />
                                        </Form.Item>
                                        <Form.Item
                                            label={t("邮箱")}
                                            name="email"
                                            rules={[{ required: true }]}
                                        >
                                            <Input autoComplete="off" />
                                        </Form.Item>
                                        <Form.Item
                                            label={t("电话")}
                                            name="phoneNumber"
                                            rules={[{ required: true }]}
                                        >
                                            <Input autoComplete="off" />
                                        </Form.Item>
                                        <Form.Item
                                            label={t("部门")}
                                            name="orgName"
                                            rules={[{ required: true }]}
                                        >
                                            <Input autoComplete="off" />
                                        </Form.Item>
                                        <Form.Item
                                            label={t("工号")}
                                            name="number"
                                            rules={[{ required: true }]}
                                        >
                                            <Input autoComplete="off" />
                                        </Form.Item>
                                        <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
                                            <Button type="primary" disabled={isSubmit} onClick={ () => { this.twoStep(); } } style={{width:"30%"}} htmlType="submit">
                                                {t("下一步")}
                                            </Button>
                                            <Button type="primary"  onClick={() => { this.prevStep(); }} style={{width:"30%", marginLeft:"40px"}}>
                                                {t("上一步")}
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                    )}
                                    {step === 2 &&(
                                        <Form
                                            ref={this.formThreeStepRef}
                                            name="basic"
                                            labelCol={{ span: 4 }}
                                            wrapperCol={{ span: 16 }}
                                            //style={{ maxWidth: 600 }}
                                            autoComplete="off"
                                            initialValues={step3Obj}
                                        >
                                            <Form.Item
                                                label={t("配置名称")}
                                                name="name"
                                                rules={[{ required: true, message: t("请输入配置名称") }]}
                                            >
                                                <Input autoComplete="off" />
                                            </Form.Item>
                                            <Form.Item
                                                label={t("同步频率")}
                                                name="syncFrequency"
                                                rules={[
                                                    { 
                                                    required: true, 
                                                    message: t("请选择同步频率") 
                                                    }
                                                ]}
                                            >
                                                <Select>
                                                    <Select.Option value="Daily">{t("每天一次")}</Select.Option>
                                                    <Select.Option value="Weekly">{t("每周一次")}</Select.Option>
                                                </Select>
                                            </Form.Item>
                                            <Form.Item
                                                label={t("状态")}
                                                name="status"
                                                rules={[
                                                    { 
                                                    required: true, 
                                                    message: t("请选择状态") 
                                                    }
                                                ]}
                                            >
                                                <Select>
                                                    <Select.Option value="Active">{t("启用")}</Select.Option>
                                                    <Select.Option value="Disabled">{t("禁用")}</Select.Option>
                                                </Select>
                                            </Form.Item>
                                            <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
                                                <Button type="primary" disabled={isSubmit} onClick={()=> isSubmit ? undefined : this.formOK() } style={{width:"30%"}} htmlType="submit">
                                                    {t("保存配置")}
                                                </Button>
                                                <Button type="primary"  onClick={() => { this.prevStep(); }} style={{width:"30%", marginLeft:"40px"}} htmlType="submit">
                                                    {t("上一步")}
                                                </Button>
                                            </Form.Item>
                                        </Form>
                                    )}
                                </div>
                            </div>
                        </Modal>
                    </>
                )
            }}</Translation>
        )
    }
}

export default connect(mapStatetoProps, {})(LdapIndex);